(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tokiol-slideshow"] && !Shopify.designMode) return;
  try {
    
  class TokiolSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.tk-slide')];
      this.i = 0;
      this.nav = this.querySelector('.tk-slides__nav');
      this.querySelectorAll('.tk-slides__btn').forEach(b => b.addEventListener('click', () => this.go(parseInt(b.dataset.dir, 10))));
      this.positionNav(); window.addEventListener('resize', () => this.positionNav());
      let x0 = null;
      this.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) this.go(dx < 0 ? 1 : -1); x0 = null; });
      if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
        const ms = Math.max(3, parseInt(this.dataset.interval || '6', 10)) * 1000;
        this.timer = setInterval(() => this.go(1), ms);
        this.addEventListener('mouseenter', () => clearInterval(this.timer));
      }
    }
    positionNav() {
      if (!this.nav) return;
      const media = this.slides[this.i]?.querySelector('.tk-slide__media');
      if (media) this.nav.style.top = (media.offsetTop + media.offsetHeight + 24) + 'px';
    }
    go(dir) {
      if (this.slides.length < 2) return;
      this.slides[this.i].classList.remove('is-active');
      this.i = (this.i + dir + this.slides.length) % this.slides.length;
      this.slides[this.i].classList.add('is-active');
      this.positionNav();
    }
  }
  if (!customElements.get('tokiol-slideshow')) customElements.define('tokiol-slideshow', TokiolSlideshow);

  } catch(e) { console.error(e); }
})();
})();
